import angular from "angular";

angular
    .module('organizationsControl.organization', [])
    .service('Organization', ['$http', function ($http) {

        function uri(id, path) {
            let link = '/control-panel/organizations';
            if (id) {
                link += '/' + id;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.store = function (params) {
            return $http.post(uri(), params);
        };

        this.update = function (id, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(id), params);
        };

        this.getBalanceData = function (id) {
            return $http.get(uri(id, 'get-balance-data'));
        };

        this.getTransactions = function (id, params) {
            return $http.get(uri(id, 'transactions'), {params: params})
        };

    }]);

export default 'organizationsControl.organization';


// WEBPACK FOOTER //
// ./resources/assets/modules/organizations-control/organization.js